import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';
import actionsFactory from 'utils/factories/actions';
import { DEPLOY } from './actionTypes';

// actions
const actions = actionsFactory(DEPLOY);
export { actions };

// reducer
const initialState = initialStateFactory();
const reducer = reducerFactory(DEPLOY);
export default (state = initialState, action) => reducer(state, action);

// sagas
const sagas = sagasFactory(DEPLOY, '/deploys');
export { sagas };
